import { GeohashGridModel, GroupClusterModel } from "../../dataViewers/map/googleMap/renderers/index.js";
const EMPTY = {};

/**
 * Creates and returns a function of form fnc( lastModel ). This will
 * check to see that the lastModel's name and objectType are correct
 * and make any corrections before returning the final model to use.
 * If any changes are made, it is made on a new model
 * @param {ModelClass} modelClass a model class with a create( layerName, name, object ) and
 * a setName() method
 */
const newModelCreator = (modelClass, opts, extend) => {
  return lastModel => {
    const {
      name,
      objectType,
      layerName
    } = opts || EMPTY;
    if (lastModel == null || lastModel.objectType !== objectType) {
      return modelClass.create(layerName, name, objectType, extend);
    }
    let lModel = {
      ...lastModel
    };
    if (modelClass.TYPE === GroupClusterModel.TYPE || modelClass.TYPE === GeohashGridModel.TYPE) {
      if (!isGeoClusterModel(lModel)) {
        lModel = modelClass.setBackupRenderer(lModel, lastModel);
      }
    }
    if (modelClass.getName(lModel) !== name) {
      return modelClass.setName(lModel, name);
    }
    if (extend?.attrName && modelClass.getAttributeName(lModel) !== extend.attrName) {
      return modelClass.setAttributeName(lModel, extend.attrName);
    }
    return lModel;
  };
};
function isGeoClusterModel(model) {
  return model?.type === GeohashGridModel.TYPE || model?.type === GroupClusterModel.TYPE;
}
export default {
  newModelCreator
};